<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'Community' }">社区生态</el-breadcrumb-item>
        <el-breadcrumb-item>{{navName}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="glag_all">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>列表</span>
          <span class="comment_btn" :class="navTop === '最新' ? 'act' : ''" @click="tabClick('time')">最新</span>
          <span class="comment_btn" :class="navTop === '最热' ? 'act' : ''" @click="tabClick('hot')">最热</span>
          <el-divider></el-divider>
        </p>
      </div>
      <none-view v-if="list.length === 0" :login="load.login" :loading="load.loading" :data="list" :text="load.text"></none-view>
      <div class="reception_live_list">
        <!-- <div v-for="item in list" :key="item.id" class="reception_live_item" @click="allJump(item.type, item.list_id, item.is_doing)"> -->
        <div v-for="(item, index) in list" :key="item.id" class="reception_live_item" @click="priceJump(item.is_buy, index, item.type, item.list_id, item.is_doing)">
          <div class="reception_live_item_top">
            <p v-if="item.is_doing === 0" class="reception_live_item_top_icon">
              {{mycommon.judgeDate(item.start_time)}} 开始
            </p>
            <p v-if="item.is_doing === 1" class="reception_live_item_top_icon">
              进行中
            </p>
            <p v-if="item.is_doing === 2" class="reception_live_item_top_icon">
              直播结束
            </p>
            <img :src="item.room_img" alt="封面">
          </div>
          <div class="reception_live_item_bottom">
            <dl class="reception_live_info">
              <dt class="reception_live_title">
                <span v-if="item.is_doing === 0" class="reception_live_title_tag">即将开始</span>
                <span v-if="item.is_doing === 1" class="reception_live_title_tag">进行中</span>
                <span v-if="item.is_buy === 1" class="reception_live_title_tag">已购买</span>
                {{item.title}}
              </dt>
              <dd class="reception_live_user">主讲人：{{item.user_name}}</dd>
            </dl>
            <div class="reception_live_list_item_other">
              <div class="reception_lately_other">
                <span v-if="item.price !== '0.00'" style="font-size: 14px;">￥<i class="font_i" style="font-size: 16px;">{{item.price}}</i></span>
                <span v-if="item.price === '0.00'" style="font-size: 16px;">￥<i class="font_i" style="font-size: 16px;">免费</i></span>
                <!-- <span v-if="item.is_doing === 0"><i class="font_i">{{item.sign_count}}</i> 人报名</span>
                <span v-if="item.is_doing === 1"><i class="font_i">{{item.read}}</i> 人观看</span>
                <span v-if="item.is_doing === 5"><i class="font_i">{{item.comment_count}}</i> 人评论</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="list.length > 0" class="hr_page lf">
      <page-button :list = "list"
      :limit = "morePage.limit"
      @page = "page"
      ref="page"></page-button>
    </div>
  </div>
</template>

<script>
import none from '../Public/none.vue'
import page from '../Public/page.vue'
export default {
  components: {
    noneView: none,
    pageButton: page
  },
  data () {
    return {
      navTop: '最新', // 排序选择
      navId: '', // 板块id
      navName: '', // 板块名称
      load: {
        login: false,
        loading: true,
        text: '暂无最近直播内容',
        data: []
      },
      list: [],
      listPage: {
        limit: 20,
        page: 1,
        nav_id: '', // 板块id
        sort: 2 // 1热度 2时间
      },
      morePage: {
        limit: 4,
        page: 1

      }
    }
  },
  created () {
    this.navId = this.$route.query.nav
    this.remakeBreadcrumb(this.navId)
    this.getLivelist()
  },
  methods: {
    // 重制面包屑
    remakeBreadcrumb (id) {
      switch (id) {
        case '5':
          this.navName = '专家学者会客厅'
          break
        case '6':
          this.navName = '行业精英工作室'
          break
        case '7':
          this.navName = '专业精英工作室'
          break
      }
    },
    // 获取信息
    getLivelist () {
      const vueThat = this
      vueThat.listPage.nav_id = vueThat.navId
      vueThat.myApi.livelist(vueThat.listPage).then((res) => {
        vueThat.load.loading = false
        if (res.data.code === 200) {
          vueThat.list.push(...res.data.data)
        }
      })
    },
    // 头部切换
    tabClick (type) {
      const vueThat = this
      vueThat.load.loading = true
      vueThat.list = []
      if (type === 'time') {
        vueThat.navTop = '最新'
        vueThat.listPage.sort = 2
      } else {
        vueThat.navTop = '最热'
        vueThat.listPage.sort = 1
      }
      vueThat.getLivelist()
    },
    priceJump (buy, index, type, listId, isDoing) {
      if (buy === 0 && this.list[index].price !== '0.00') {
        this.$alert('本视频为付费视频，请您下载APP，完成支付！', '温馨提示', {
          type: 'error',
          confirmButtonText: '下载APP',
          showClose: true
        }).then(() => {
          const routeData = this.$router.resolve({
            path: '/down'
          })
          window.open(routeData.href, '_blank')
        })
      } else {
        this.allJump(type, listId, isDoing)
      }
    },
    allJump (type, listId, isDoing) {
      this.mycommon.allJump(this, type, listId, this.navId, isDoing)
    },
    // 加载更多
    page (num) {
      this.listPage.page = num
      this.getLivelist()
    }
  }
}
</script>

<style>
</style>
